export default __webpack_public_path__ + "449ef45b04f98cc88d7da03e56d2549c.svg";